import { ReactElement } from "react"
import { Navigate } from "react-router-dom"
import { useAppSelector } from "reducers/store"
import { useAppDispatch } from "reducers/store"
import { checkUserToken } from "reducers/user/user-actions"

interface PrivateRouteProps {
  outlet: ReactElement
}

const PrivateRoute = (props: PrivateRouteProps) => {
  const { outlet } = props

  const appDispatch = useAppDispatch()

  appDispatch(checkUserToken())

  const isAuthenticated = useAppSelector(({ user: { authentication } }) => authentication.isAuthenticated)

  return isAuthenticated ? outlet : <Navigate to={{ pathname: "/login" }} replace />
}

export default PrivateRoute
